import { render } from "./subholding-deletion-modal.vue?vue&type=template&id=dd4583da"
import script from "./subholding-deletion-modal.vue?vue&type=script&lang=js"
export * from "./subholding-deletion-modal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__